import { render, staticRenderFns } from "./IdeiaCover.vue?vue&type=template&id=258776d8&scoped=true&"
import script from "./IdeiaCover.vue?vue&type=script&lang=js&"
export * from "./IdeiaCover.vue?vue&type=script&lang=js&"
import style0 from "./IdeiaCover.vue?vue&type=style&index=0&id=258776d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258776d8",
  null
  
)

export default component.exports